module.exports = __webpack_public_path__ + "static/allosim-2844fb6f3b567f0e5147a02e0286290f.jpg";